import Header from "../components/layout/Header"
import CategoryList from "../components/home/CategoryList"
import { useState, useEffect } from "react"
import axios from "axios"
import Footer from "../components/layout/Footer"
import SimilarProducts from "../components/home/SimilarProducts"
import { useParams } from "react-router-dom"
import { toast } from "../utils/toast"

function SingleProductPage() {
    const { id } = useParams()
    const [product, setProduct] = useState({})

    const getData = async () => {
        try {
            let res = await axios.get(`http://localhost:3004/posts/${id}`)
            setProduct(res.data)
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getData()
    }, [id])

    const handleAddtocart = async () => {
        let send = {
            id: product.id,
            no: 1,
            image: product.image,
            name: product.name,
            price: product.price,
            priceA: product.priceA,
            cuttoff: product.cuttoff,
            ram: product.rgWa7D,
            subtotal: product.priceA
        }
        try {
            let res = await axios.post(`http://localhost:3004/profile `, {
                ...send
            })
            console.log(res)
            toast.success("Added to cart!")
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <div style={{ paddingTop: '128px', backgroundColor: '#fff' }}>
            <Header />
            <CategoryList />
            <div style={{ maxWidth: '1340px', margin: '0 auto', padding: '24px 16px' }}>
                <div style={{ display: 'flex', gap: '32px', alignItems: 'flex-start' }}>
                    {/* Left: Image Gallery */}
                    <div style={{ width: '50%' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
                            {[1, 2].map((i) => (
                                <div key={i} style={{ backgroundColor: '#f5f5f5', height: '600px', display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
                                    <img
                                        src="https://rukminim2.flixcart.com/image/612/612/xif0q/jean/r/w/n/30-j-54-light-blue-comfits-original-imahy358ggrs43x5.jpeg?q=70"
                                        alt="Product"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right: Product Details */}
                    <div style={{ width: '50%', paddingLeft: '16px' }}>
                        {/* Sizes */}
                        <div style={{ marginBottom: '24px' }}>
                            <p style={{ fontWeight: '600', fontSize: '16px', color: '#212121', marginTop: '16px', marginBottom: '8px', margin: '16px 0 8px 0' }}>
                                Select Size <span style={{ color: 'var(--color-primary)', cursor: 'pointer', fontSize: '14px', marginLeft: '8px' }}>Size chart</span>
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {['28', '30', '32', '34', '36'].map(size => (
                                    <div
                                        key={size}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            fontWeight: '500',
                                            color: '#212121',
                                            transition: '0.2s'
                                        }}
                                        className="size-option"
                                    >
                                        {size}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Title & Brand */}
                        <p style={{ color: 'var(--color-primary)', fontWeight: '600', fontSize: '14px', marginBottom: '4px', cursor: 'pointer', margin: '0 0 4px 0' }}>Visit brand store</p>
                        <h1 style={{ fontSize: '18px', color: '#212121', marginBottom: '8px', fontWeight: 'normal', margin: '0 0 8px 0' }}>BREXX Men Straight Fit Mid Rise Blue Jeans</h1>
                        <div style={{ backgroundColor: '#388e3c', color: 'white', padding: '2px 8px', borderRadius: '2px', display: 'inline-block', fontSize: '12px', fontWeight: '600', marginBottom: '12px' }}>
                            Hot Deal
                        </div>

                        {/* Prices */}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '16px' }}>
                            <span style={{ color: '#388e3c', fontSize: '28px', fontWeight: '600' }}>↓82%</span>
                            <span style={{ color: '#878787', fontSize: '20px', textDecoration: 'line-through' }}>2,499</span>
                            <span style={{ color: '#212121', fontSize: '28px', fontWeight: '600' }}>₹446</span>
                        </div>

                        {/* WOW Deal Box */}
                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginBottom: '24px' }}>
                            <div style={{ backgroundColor: 'var(--color-primary)', color: 'white', padding: '8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ backgroundColor: 'white', color: 'var(--color-primary)', padding: '0 4px', borderRadius: '2px', fontSize: '10px', fontWeight: '800' }}>WOW DEAL</span>
                                    <span style={{ fontWeight: '600', fontSize: '14px' }}>Apply offers for maximum savings</span>
                                </div>
                            </div>
                            <div style={{ padding: '16px', backgroundColor: '#f5faff' }}>
                                <p style={{ fontWeight: '600', fontSize: '16px', color: '#212121', marginBottom: '12px', margin: '0 0 12px 0' }}>Buy at ₹396</p>
                                <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '8px' }} className="no-scrollbar">
                                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', backgroundColor: 'white', padding: '12px', minWidth: '220px' }}>
                                        <div style={{ backgroundColor: 'var(--color-accent)', color: '#212121', padding: '0 4px', borderRadius: '2px', fontSize: '10px', fontWeight: '600', display: 'inline-block', marginBottom: '8px' }}>Best value for you</div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div>
                                                <p style={{ fontWeight: '600', fontSize: '14px', margin: 0 }}>₹50 off</p>
                                                <p style={{ fontSize: '12px', color: '#878787', margin: 0 }}>BHIM</p>
                                            </div>
                                            <span style={{ fontWeight: '600', color: 'var(--color-primary)', fontSize: '14px', cursor: 'pointer' }}>Apply</span>
                                        </div>
                                        <p style={{ marginTop: '8px', fontSize: '12px', color: '#212121', margin: '8px 0 0 0' }}>UPI • Cashback</p>
                                    </div>
                                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', backgroundColor: 'white', padding: '12px', minWidth: '220px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div>
                                                <p style={{ fontWeight: '600', fontSize: '14px', margin: 0 }}>₹23 off</p>
                                                <p style={{ fontSize: '12px', color: '#878787', margin: 0 }}>HoneyCool Axis</p>
                                            </div>
                                            <span style={{ fontWeight: '600', color: 'var(--color-primary)', fontSize: '14px', cursor: 'pointer' }}>Apply</span>
                                        </div>
                                        <p style={{ marginTop: '8px', fontSize: '12px', color: '#212121', margin: '8px 0 0 0' }}>Credit Card • Cashback</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Delivery */}
                        <p style={{ fontWeight: '600', fontSize: '16px', color: '#212121', marginBottom: '12px', margin: '0 0 12px 0' }}>Delivery details</p>
                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '24px' }}>
                            <div style={{ padding: '12px', borderBottom: '1px solid #e0e0e0', backgroundColor: '#f2f8ff', display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontSize: '14px', color: '#212121', fontWeight: '500' }}>Location not set</span>
                                <span style={{ marginLeft: '4px', fontSize: '14px', color: 'var(--color-primary)', fontWeight: '500', cursor: 'pointer' }}>Select delivery location</span>
                            </div>
                            <div style={{ padding: '12px', borderBottom: '1px solid #e0e0e0' }}>
                                <p style={{ fontWeight: '600', fontSize: '14px', color: '#212121', margin: 0 }}>Delivery by 5 Apr, Sun</p>
                                <p style={{ fontSize: '12px', color: 'var(--color-secondary)', margin: 0 }}>Order in 00h 16m 40s</p>
                            </div>
                            <div style={{ padding: '12px' }}>
                                <p style={{ fontSize: '13px', color: '#878787', margin: 0 }}>Fulfilled by Anikaenterprises2024</p>
                            </div>
                        </div>

                        {/* Actions */}
                        <div style={{ display: 'flex', gap: '16px' }}>
                            <button
                                onClick={handleAddtocart}
                                style={{
                                    flex: 1,
                                    backgroundColor: 'white',
                                    color: '#212121',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    height: '52px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f7fafc'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                            >
                                Add to cart
                            </button>
                            <button
                                style={{
                                    flex: 1,
                                    backgroundColor: 'var(--color-accent)',
                                    color: '#212121',
                                    border: 'none',
                                    borderRadius: '4px',
                                    height: '52px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = 'var(--color-accent)'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'var(--color-accent)'}
                            >
                                Buy at ₹446
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Similar Products Sections */}
            <div style={{ maxWidth: '1340px', margin: '0 auto', padding: '0 16px' }}>
                <SimilarProducts />
            </div>

            <Footer />
            <style>
                {`
                .size-option:hover {
                    border-color: var(--color-primary) !important;
                    color: var(--color-primary) !important;
                }
                `}
            </style>
        </div>
    );
}

export default SingleProductPage;